import DocPage from '../components/DocPage.jsx'
import { docsMovieNight } from '../content.js'

// /docs/movie-night — P6-104. Moved out of the single /docs page, not rewritten:
// same paragraph, same Sun–Fri timeline, same "the wheel, and why it is mostly
// gone" disclosure. See content-src/docs-movie-night.json.
//
// Four lines, like Explainer.jsx and Documentation.jsx before it, because the
// page TYPE already existed. That is the whole return on having extracted
// components/DocPage.jsx in P6-2 — splitting one document into four cost four
// content files and four files this size, and no new design at all.

export default function DocsMovieNight() {
  return <DocPage doc={docsMovieNight} />
}
